<template>
  <b-row class="my-3">
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group
        label="Forgot MPIN"
        class="mb-2"
        label-class="head-label"
      >
          <p>Please enter your mobile number for us to verify your account.</p>
      </b-form-group>
      <b-form-group :state="isInvalid('mobile_number')" label="Mobile Number">
        <b-input-group>
          <b-input-group-prepend is-text id="mobile-prepend"
            >+63</b-input-group-prepend
          >
          <b-form-input
            v-model="form.mobile_number"
            maxlength="10"
            @keypress.native="filterNumeric"
            @keyup.native="trimNumber('mobile_number')"
            :state="isInvalid('mobile_number')"
            placeholder="Enter Mobile Number"
            pattern="[0-9]*"
            inputmode="numeric"
          >
          </b-form-input>
        </b-input-group>
        <b-form-invalid-feedback :state="isInvalid('mobile_number')">
          {{ errorMessage("mobile_number") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-button
          variant="primary"
          pill
          block
          class="text-white"
          @click="validateField"
          :disabled="isLoading">
          Proceed
        </b-button>
      </b-form-group>
      <b-form-group>
        <router-link
          :to="{ name: 'Login' }"
          class="text-muted">
          Back to Login
        </router-link>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import notification from "@/services/notification";

function initForm() {
  return {
    mobile_number: null
  }
}

export default {
  name: "ForgotMPIN",
  data() {
    return {
      form: initForm()
    }
  },
  computed: {
    ...mapGetters("auth", ["isLoading", "errors"])
  },
  beforeDestroy() {
    this.setErrors(null);
  },
  methods: {
    ...mapMutations("auth", ["setErrors"]),
    ...mapActions("auth", ["sendOtp"]),
    isNotNumeric(input) {
      return /[^0-9]/g.test(input);
    },
    filterNumeric(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    validateField() {
      const errors = {};
      if (!this.form.mobile_number) errors["mobile_number"] = "Mobile number is required";
      else if (this.form.mobile_number && this.isNotNumeric(this.form.mobile_number)) errors["mobile_number"] = "Only numeric characters are allowed";

      this.setErrors(errors);

      if (Object.keys(errors).length === 0) this.submitForm();
      else notification.warning("Oops, something went wrong.");
    },
    async submitForm() {
      const payload = {
        mobile_number: this.form.mobile_number,
        action: "FORGOT_PIN_MOBILE"
      };
      localStorage.setItem("active-reset-password", true);
      await this.sendOtp(payload)
        .then(() => {
          if (this.errors === null || Object.keys(this.errors).length === 0) {
            this.$router.push({ name: "Verify" });
          }
        });
    },
    trimNumber: function(ref) {
      if (this.form[ref])
        this.form[ref] = this.form[ref].replace(/\D/g, "");
    },
  }
}
</script>
